import { WISDOM_CAPABILITIES } from '@modules/oracle/constants';
import { MenuBookRounded } from '@mui/icons-material';
import { Chip, Grid2, IconButton, StackProps, Tooltip } from '@mui/material';
import { useState } from 'react';

interface WisdomCapabilitiesProps {
  onSelect: (prompt: string) => void;
  sx?: StackProps['sx'];
}

const MINIMUM_CAPABILITIES_LIMIT = 3;

export function WisdomCapabilities({ onSelect, sx }: WisdomCapabilitiesProps) {
  const [shouldShowAll, setShouldShowAll] = useState(false);

  return (
    <Grid2
      container
      justifyContent="center"
      alignItems="center"
      spacing={1}
      sx={{ ...sx }}
    >
      {WISDOM_CAPABILITIES.map((capability, index) => {
        if (!shouldShowAll && index > MINIMUM_CAPABILITIES_LIMIT) {
          return null;
        }

        return (
          <Grid2 size="auto" key={capability.prompt}>
            <Chip
              icon={capability.icon}
              label={capability.label}
              variant="outlined"
              onClick={() => onSelect(capability.prompt)}
            />
          </Grid2>
        );
      })}
      {shouldShowAll ? null : (
        <Grid2 size="auto" key="more">
          <Chip
            label="More"
            variant="outlined"
            onClick={() => setShouldShowAll(true)}
          />
        </Grid2>
      )}
      <Grid2 size="auto" key="library">
        <Tooltip title="Open prompt library" arrow placement="top">
          <IconButton
            color="primary"
            target="_blank"
            href="https://helpcenter.enterpret.com/en/articles/9711115-examples-of-wisdom-prompts"
          >
            <MenuBookRounded />
          </IconButton>
        </Tooltip>
      </Grid2>
    </Grid2>
  );
}
